"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useText = void 0;
const react_1 = require("react");
function validateText(text, maximum) {
    if (text.length > maximum) {
        return 'overflow';
    }
    if (text.replace(/\s/g, '') === '') {
        return 'empty';
    }
    return 'valid';
}
function useText(initial, maxLen) {
    const [text, setText] = (0, react_1.useState)({ text: initial !== null && initial !== void 0 ? initial : '', textValidity: 'initial' });
    const handleTextChange = (0, react_1.useCallback)((event) => {
        const bodyText = event.target.value;
        const isBodyValid = validateText(bodyText, maxLen);
        setText({
            text: bodyText,
            textValidity: isBodyValid,
        });
    }, [maxLen]);
    return { text, handleTextChange };
}
exports.useText = useText;
//# sourceMappingURL=useText.js.map